import { DirectUpload } from 'activestorage';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';

export function useFileUpload() {
  const store = useStore();
  const { accountId: currentAccountId } = useAccount();
  const currentUser = store.getters.getCurrentUser;

  const uploadFile = async (file, knowledgebaseId) => {
    const upload = new DirectUpload(
      file,
      `/api/v1/accounts/${currentAccountId.value}/knowledgebases/${knowledgebaseId}/direct_uploads`,
      {
        directUploadWillCreateBlobWithXHR: xhr => {
          xhr.setRequestHeader('api_access_token', currentUser.access_token);
        },
      }
    );

    return new Promise((resolve, reject) => {
      upload.create((error, blob) => {
        if (error) {
          useAlert(error);
          reject(error);
        } else {
          resolve(blob);
        }
      });
    });
  };

  const attachFile = async ({ upload, knowledgebaseId }) => {
    try {
      await store.dispatch('records/create', {
        record: { file: upload.signed_id },
        knowledgebaseId,
      });
      useAlert('File uploaded successfully.');
    } catch (error) {
      const errorMessage =
        error?.response?.message ||
        'An error occurred while uploading the file.';
      useAlert(errorMessage);
    }
  };

  return {
    uploadFile,
    attachFile,
  };
}
